export default __webpack_public_path__ + "static/O0067-840851606db30bf4c5e26adb7f29cb2e.png";